import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=12d7a6f0&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=12d7a6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7a6f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d7a6f0')) {
      api.createRecord('12d7a6f0', component.options)
    } else {
      api.reload('12d7a6f0', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=12d7a6f0&scoped=true&", function () {
      api.rerender('12d7a6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gRx526JSnqot/JS/comp/SearchFilterTokens.vue"
export default component.exports